import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import Map from "../components/Map"

const IndexPage = () => (
  <Layout>
    <SEO
      title="SARS-CoV-2 infections in Switzerland"
      description="An interactive chart showing the reported number of confirmed infections with SARS-CoV-2 by canton over time."
    />
    <Map />
  </Layout>
)

export default IndexPage
